import login from '@/server/login.js'
import router, { resetRouter } from '@/router'

const state = {
    token: '',
    name: '',
    id: '',
    avatar: '',
    introduction: '',
    roles: []
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
        sessionStorage.setItem('token', token)

    },
    SET_NAME: (state, {name, id}) => {
        state.name = name
        state.id = id
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles
    }
}

const actions = {
    // user login
    login({ commit }, userInfo) {
        const { loginAccount, password } = userInfo
        return new Promise((resolve, reject) => {
            login.signin({ loginAccount: loginAccount.trim(), password: password }, res => {
                const { data } = res
                commit('SET_TOKEN', data)
				console.log(resolve())
                resolve()
            })
        })
    },


    // get user info
    getInfo({ commit, state }) {
        return new Promise((resolve, reject) => {
            login.userInfo(res => {
                const { data } = res
                const { permissionTree, username, id} = data
                
                sessionStorage.setItem('userInfo',JSON.stringify(res.data))
                commit('SET_ROLES', handlePermission(permissionTree))
                commit('SET_NAME', {
                    name: username,
                    id
                })
                
                resolve({
                    roles: state.roles,
                    name: state.name,
                    id: state.id
                })
            },err=>{
                reject()
            })
        })
    },

    // user logout
    logout({ commit }) {
        return new Promise((resolve, reject) => {
            login.signOut(() => {
                commit('SET_TOKEN', '')
                commit('SET_NAME', {
                    name: '',
                    id: ''
                })
                commit('SET_ROLES', [])
                resetRouter()
                resolve()
            })            
        })
    },
}

// 处理权限树转换成字符串数组Array: string
function handlePermission(permissionTree) {
    let resultArr = []
    if (permissionTree.length > 0) {
        permissionTree.forEach(item => {
            resultArr.push(item.code)

            if (item.children) {
                resultArr = resultArr.concat(handlePermission(item.children))
            }
        })
    }

    return resultArr
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}